var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"data-table-item-key-value"},[_c('VTextarea',{attrs:{"label":_vm.label,"dense":"","hide-details":"","outlined":"","readonly":"","rows":"1","value":_vm.keyValue}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }